import Alert from "@cloudscape-design/components/alert"
import Box from "@cloudscape-design/components/box"

interface ProtocolAlertProps {
  /**
   * Alert message to display.
   */
  message: string
  /**
   * Alert variant determining color scheme.
   */
  variant?: "error" | "warning" | "info"
}

/**
 * Displays an alert message with appropriate styling.
 *
 * Used for showing upload errors, validation messages, and other notifications within
 * protocol-related components.
 */
const ProtocolAlert = ({ message, variant = "error" }: ProtocolAlertProps) => (
  <Box margin={{ bottom: "m" }}>
    <Alert type={variant}>{message}</Alert>
  </Box>
)

export default ProtocolAlert
